import { Box } from '@chakra-ui/react';

// import { AboutUsTemplate } from '../model';
import { AboutUsAwardsSection } from './about-us-awards-section';
import { EmpowerSection } from './empower-section';
import { AboutUsFooterBannerSection } from './footer-banner-section';
import { FutureSection } from './future-section';
import { HeroSection } from './hero-section';
import { IntroSection } from './intro-section';
// import { TeamMembersSection } from './team-members-section';

// Temporarily not accepting aboutUsTemplate — the TeamMembers section is
// disabled and no other section reads it. Re-enable when the section is restored.
export function AboutUs() {
  return (
    <Box bg='white'>
      <HeroSection />
      <IntroSection />
      <EmpowerSection />
      <AboutUsAwardsSection />
      <FutureSection />
      {/* Temporarily hidden per stakeholder request — re-enable when approved.
          <TeamMembersSection teamMembers={aboutUsTemplate.teamMembers} /> */}
      <AboutUsFooterBannerSection />
    </Box>
  );
}
